export const columns = [
  {
    title: 'page_tenant_operation',
    key: 'action',
    width: 170,
    ellipsis: true,
    scopedSlots: { customRender: 'action' }
  },
  {
    title: 'page_tenant_tenant_number',
    dataIndex: 'tenantCode',
    key: 'tenantCode',
    ellipsis: true,
    width: 184,
    scopedSlots: { customRender: 'tenantCode' }
  },
  {
    title: 'page_tenant_tenant_name',
    dataIndex: 'tenantName',
    key: 'tenantName',
    width: 184,
    ellipsis: true,
    scopedSlots: { customRender: 'tenantName' }
  },
  {
    title: 'page_tenant_contacts',
    dataIndex: 'linkman',
    key: 'linkman',
    ellipsis: true,
    width: 184,
    scopedSlots: { customRender: 'linkman' }
  },
  {
    title: 'page_tenant_contact_number',
    dataIndex: 'contactNumber',
    key: 'contactNumber',
    width: 163,
    ellipsis: true,
    scopedSlots: { customRender: 'contactNumber' }
  },
  {
    title: 'page_tenant_account_quota',
    dataIndex: 'accountNumber',
    key: 'accountNumber',
    wdith: 166,
    ellipsis: true,
    scopedSlots: { customRender: 'accountNumber' }
  },
  {
    title: 'page_tenant_expiration_date',
    dataIndex: 'expireTime',
    key: 'expireTime',
    width: 166,
    ellipsis: true,
    scopedSlots: { customRender: 'expireTime' }
  }
]
